import type { FormResponseRange } from "../types";

/** Query string for the form responses list / CSV export (OWN-147b date filter). */
export function formResponsesQuery(params: FormResponseRange & { cursor?: string }): string {
  const q = new URLSearchParams();
  if (params.cursor) q.set("cursor", params.cursor);
  if (params.from) q.set("from", params.from);
  if (params.to) q.set("to", params.to);
  const text = q.toString();
  return text ? "?" + text : "";
}
